// ------------------------------------
// Constants
// ------------------------------------
export const NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST = 'NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST';
export const NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_SUCCESS = 'NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_SUCCESS';
export const NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_FAILURE = 'NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(res) {
  return {
    type: NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_SUCCESS,
    data: res,
  };
}

export function requestFailure(error) {
  return {
    type: NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_FAILURE,
    error,
  };
}
